//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Calendar
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

// Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";
export const DELETE_MESSAGE = "delete/message";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";
export const UNREAD_MAIL = "/unread/mail";
export const STARED_MAIL = "/stared/mail";
export const LABEL_MAIL = "/label/mail";
export const TRASH_MAIL = "/trash/mail";

// Ecommerce
// Product
export const GET_PRODUCTS = "/apps/product";
export const DELETE_PRODUCT = "/apps/product";
export const ADD_NEW_PRODUCT = "/apps/product";
export const UPDATE_PRODUCT = "/apps/product";

// Orders
export const GET_ORDERS = "/apps/order";
export const ADD_NEW_ORDER = "/apps/order";
export const UPDATE_ORDER = "/apps/order";
export const DELETE_ORDER = "/apps/order";

// Customers
export const GET_CUSTOMERS = "/apps/customer";
export const ADD_NEW_CUSTOMER = "/apps/customer";
export const UPDATE_CUSTOMER = "/apps/customer";
export const DELETE_CUSTOMER = "/apps/customer";

// Sellers
export const GET_SELLERS = "/sellers";

// Project list
export const GET_PROJECT_LIST = "/project/list";

// Task
export const GET_TASK_LIST = "/apps/task";
export const ADD_NEW_TASK = "/apps/task";
export const UPDATE_TASK = "/apps/task";
export const DELETE_TASK = "/apps/task";

// kanban
export const GET_TASKS = "/apps/tasks";
export const ADD_TASKS = "/add/tasks";
export const UPDATE_TASKS = "/update/tasks";
export const DELETE_TASKS = "/delete/tasks";

// CRM
// Conatct
export const GET_CONTACTS = "/apps/contact";
export const ADD_NEW_CONTACT = "/apps/contact";
export const UPDATE_CONTACT = "/apps/contact";
export const DELETE_CONTACT = "/apps/contact";

// Companies
export const GET_COMPANIES = "/apps/company";
export const ADD_NEW_COMPANIES = "/apps/company";
export const UPDATE_COMPANIES = "/apps/company";
export const DELETE_COMPANIES = "/apps/company";

// Lead
export const GET_LEADS = "/apps/lead";
export const ADD_NEW_LEAD = "/apps/lead";
export const UPDATE_LEAD = "/apps/lead";
export const DELETE_LEAD = "/apps/lead";

// Deals
export const GET_DEALS = "/deals";

// Crypto
export const GET_TRANSACTION_LIST = "/transaction-list";
export const GET_ORDRER_LIST = "/order-list";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const ADD_NEW_INVOICE = "/apps/invoice";
export const UPDATE_INVOICE = "/apps/invoice";
export const DELETE_INVOICE = "/apps/invoice";

// TicketsList
export const GET_TICKETS_LIST = "/apps/ticket";
export const ADD_NEW_TICKET = "/apps/ticket";
export const UPDATE_TICKET = "/apps/ticket";
export const DELETE_TICKET = "/apps/ticket";

// Dashboard Analytics

// Sessions by Countries
export const GET_ALL_DATA = "/all-data";
export const GET_HALFYEARLY_DATA = "/halfyearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

// Audiences Metrics
export const GET_ALLAUDIENCESMETRICS_DATA = "/allAudiencesMetrics-data";
export const GET_MONTHLYAUDIENCESMETRICS_DATA = "/monthlyAudiencesMetrics-data";
export const GET_HALFYEARLYAUDIENCESMETRICS_DATA = "/halfyearlyAudiencesMetrics-data";
export const GET_YEARLYAUDIENCESMETRICS_DATA = "/yearlyAudiencesMetrics-data";

// Users by Device
export const GET_TODAYDEVICE_DATA = "/todayDevice-data";
export const GET_LASTWEEKDEVICE_DATA = "/lastWeekDevice-data";
export const GET_LASTMONTHDEVICE_DATA = "/lastMonthDevice-data";
export const GET_CURRENTYEARDEVICE_DATA = "/currentYearDevice-data";

// Audiences Sessions by Country
export const GET_TODAYSESSION_DATA = "/todaySession-data";
export const GET_LASTWEEKSESSION_DATA = "/lastWeekSession-data";
export const GET_LASTMONTHSESSION_DATA = "/lastMonthSession-data";
export const GET_CURRENTYEARSESSION_DATA = "/currentYearSession-data";

// Dashboard CRM

// Balance Overview
export const GET_TODAYBALANCE_DATA = "/todayBalance-data";
export const GET_LASTWEEKBALANCE_DATA = "/lastWeekBalance-data";
export const GET_LASTMONTHBALANCE_DATA = "/lastMonthBalance-data";
export const GET_CURRENTYEARBALANCE_DATA = "/currentYearBalance-data";

// Deal type
export const GET_TODAYDEAL_DATA = "/todayDeal-data";
export const GET_WEEKLYDEAL_DATA = "/weeklyDeal-data";
export const GET_MONTHLYDEAL_DATA = "/monthlyDeal-data";
export const GET_YEARLYDEAL_DATA = "/yearlyDeal-data";

// Sales Forecast

export const GET_OCTSALES_DATA = "/octSales-data";
export const GET_NOVSALES_DATA = "/novSales-data";
export const GET_DECSALES_DATA = "/decSales-data";
export const GET_JANSALES_DATA = "/janSales-data";

// Dashboard Ecommerce
// Revenue
export const GET_ALLREVENUE_DATA = "/allRevenue-data";
export const GET_MONTHREVENUE_DATA = "/monthRevenue-data";
export const GET_HALFYEARREVENUE_DATA = "/halfYearRevenue-data";
export const GET_YEARREVENUE_DATA = "/yearRevenue-data";

// Dashboard Job
// Applications Statistic
export const GET_APPLICTION_DATA = "/applictionStatistic-data";

// Dashboard Crypto
// Portfolio
export const GET_BTCPORTFOLIO_DATA = "/btcPortfolio-data";
export const GET_USDPORTFOLIO_DATA = "/usdPortfolio-data";
export const GET_EUROPORTFOLIO_DATA = "/euroPortfolio-data";

// Market Graph
export const GET_ALLMARKETDATA_DATA = "/allMarket-data";
export const GET_YEARMARKET_DATA = "/yearMarket-data";
export const GET_MONTHMARKET_DATA = "/monthMarket-data";
export const GET_WEEKMARKET_DATA = "/weekMarket-data";
export const GET_HOURMARKET_DATA = "/hourMarket-data";

// Dashboard Crypto
// Project Overview
export const GET_ALLPROJECT_DATA = "/allProject-data";
export const GET_MONTHPROJECT_DATA = "/monthProject-data";
export const GET_HALFYEARPROJECT_DATA = "/halfYearProject-data";
export const GET_YEARPROJECT_DATA = "/yearProject-data";

// Project Status
export const GET_ALLPROJECTSTATUS_DATA = "/allProjectStatus-data";
export const GET_WEEKPROJECTSTATUS_DATA = "/weekProjectStatus-data";
export const GET_MONTHPROJECTSTATUS_DATA = "/monthProjectStatus-data";
export const GET_QUARTERPROJECTSTATUS_DATA = "/quarterProjectStatus-data";

// job
export const GET_JOBAPPLICATIONSTATISTIC = "/applicationstatistic"

// Dashboard NFT
// Marketplace
export const GET_ALLMARKETPLACE_DATA = "/allMarketplace-data";
export const GET_MONTHMARKETPLACE_DATA = "/monthMarketplace-data";
export const GET_HALFYEARMARKETPLACE_DATA = "/halfYearMarketplace-data";
export const GET_YEARMARKETPLACE_DATA = "/yearMarketplace-data";

// Project
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

// Pages > Team
export const GET_TEAMDATA = "/teamData";
export const DELETE_TEAMDATA = "/delete/teamData";
export const ADD_NEW_TEAMDATA = "/add/teamData";
export const UPDATE_TEAMDATA = "/update/teamData";

// File Manager
// Folder
export const GET_FOLDERS = "/folder";
export const DELETE_FOLDER = "/delete/folder";
export const ADD_NEW_FOLDER = "/add/folder";
export const UPDATE_FOLDER = "/update/folder";

// File
export const GET_FILES = "/file";
export const DELETE_FILE = "/delete/file";
export const ADD_NEW_FILE = "/add/file";
export const UPDATE_FILE = "/update/file";

// To do
export const GET_TODOS = "/todo";
export const DELETE_TODO = "/delete/todo";
export const ADD_NEW_TODO = "/add/todo";
export const UPDATE_TODO = "/update/todo";

// To do Project
export const GET_PROJECTS = "/projects";
export const ADD_NEW_TODO_PROJECT = "/add/project";

//JOB APPLICATION
export const GET_APPLICATION_LIST = "/application-list";
export const ADD_NEW_APPLICATION_LIST = "/add/application-list";
export const UPDATE_APPLICATION_LIST = "/update/application-list";
export const DELETE_APPLICATION_LIST = "/delete/application-list";

//JOB APPLICATION
export const GET_API_KEY = "/api-key";

// CANDIDATE LIST
export const GET_CANDIDATE = "/candidates";
export const ADD_NEW_CANDIDATE = "add/candidates";
export const UPDATE_CANDIDATE = "update/candidates";
export const DELETE_CANDIDATE = "delete/candidates"

export const GET_CANDIDATE_GRID = "/category-grid";
export const ADD_CANDIDATE_GRID = "/add/category-grid";

export const GET_CATEGORY_LIST = "/category-list";
export const ADD_CATEGORY_LIST = "/add/category-list";

// co2
// login
export const LOGIN = "/api/login";
export const RESEND_MOBILE_OTP = "/api/resend-mobile-otp";
export const CHECK_PASSCODE_LOGIN = "/api/check-passcode-login";
export const CANCEL_LOGIN = "/api/cancel-login";

//registration
export const REGISTER                       = (path: string) => `/api${path}`;
export const CHECK_EMAIL_VERIFICATION       = (path: string) => `/api${path}/check-passcode`;
export const REGISTER_ADMIN_USER            = (path: string) => `/api${path}/create-admin-user`;
export const REGISTRATION_STATUS            = (path: string) => `/api${path}/check-status`;
export const ON_SKIP                        = (path: string) => `/api${path}/actions/skip`;
export const GET_ACTION                     = (path: string) => `/api${path}/actions/get`;
export const ON_BACK                        = (path: string) => `/api${path}/actions/back`;
export const ON_CANCEL                      = (path: string) => `/api${path}/actions/cancel`;
export const CANCEL_REGISTRATION           = (path: string) => `/api${path}/cancel-registration`;
export const CHECK_MOBILE_VERIFICATION      = (path: string) => `/api${path}/verify-mobile-phone`;
export const REGISTER_BUSINESS              = (path: string) => `/api${path}/set-details`;
export const ACCOUNT_TYPE                   = (path: string) => `/api${path}/set-account-type`;
export const REGISTER_SITE                  = (path: string) => `/api${path}/set-address`;
export const GET_SITE_OWNERSHIP_OPTIONS     = (path: string) => `/api${path}/address-settings`;
export const LICENSE_PLAN_CALCULATE         = (path: string) => `/api${path}/license/calculate`;
export const LICENSE_PLAN_CREATE            = (path: string) => `/api${path}/license/create`;
const resolveLicenseVoucherFlowPath = (path: string) =>
	path?.startsWith("/register") ? path : "/register";

export const LICENSE_VOUCHER_APPLY          = (path: string) => `/api${resolveLicenseVoucherFlowPath(path)}/license/voucher/apply`;
export const LICENSE_VOUCHER_CLEAR          = (path: string) => `/api${resolveLicenseVoucherFlowPath(path)}/license/voucher/clear`;
export const LICENSE_PLAN_GET  = `/api/license/plans`;
export const TOKEN_TOP_UP_PLANS_GET = `/api/tokens/top-up-plans`;
export const TOKEN_TOP_UP_PREVIEW = `/api/tokens/top-up/preview`;
export const TOKEN_TOP_UP_PURCHASE = `/api/tokens/top-up`;
export const TOKEN_USAGE_GET = `/api/tokens/usage`;
export const LICENSE_TRIAL_SUMMARY_GET = `/api/license/trial-summary`;
export const TOKEN_AUTO_TOP_UP = `/api/tokens/auto-top-up`;
export const ADMIN_TOKEN_TRANSACTIONS_CREATE = `/api/admin/token-transactions/create`;
export const LICENSE_TOGGLE_AUTO_RENEWAL = `/api/licenses/toggle-auto-renewal`;
export const STRIPE_CUSTOMER_PORTAL = `/api/stripe/customer-portal`;
export const STRIPE_CHECKOUT_SUCCESS = `/api/stripe/checkout-success`;

// In-app subscription management endpoints
export const STRIPE_CREATE_SUBSCRIPTION = `/api/stripe/create-subscription`;
export const STRIPE_GET_SUBSCRIPTION = `/api/licenses/subscription`;
export const LICENSE_RENEWAL_DETAILS = (licenseId: number | string) => `/api/licenses/${licenseId}/renewal-details`;
export const LICENSE_MODIFY_PREVIEW = `/api/licenses/modify/preview`;
export const LICENSE_MODIFY_COMMIT = `/api/licenses/modify/commit`;
export const LICENSE_CHANGE_PLAN_PREVIEW = `/api/licenses/change-plan/preview`;
export const LICENSE_CHANGE_PLAN_COMMIT = `/api/licenses/change-plan/commit`;
export const STRIPE_ADD_PAYMENT_METHOD = `/api/stripe/add-payment-method`;
export const STRIPE_REMOVE_PAYMENT_METHOD = `/api/stripe/remove-payment-method`;
export const STRIPE_FINALIZE_ZERO_AMOUNT = `/api/stripe/finalize-zero-amount`;
export const STRIPE_PENDING_RENEWAL = `/api/licenses/pending-renewal`;

export const PROCESS_PAYMENT = "/api/payments/process";
export const CHECK_AFFILIATE_REGISTRATION_STATUS = "/api/business/check-affiliate-registration-status";
export const SEND_INVOICE_EMAIL_PASSCODE = "/api/business/send-invoice-email-passcode";
export const VERIFY_INVOICE_EMAIL = "/api/business/verify-invoice-email";

/*export const REGISTER = "/api/register";
export const CHECK_EMAIL_VERIFICATION = "/api/check-passcode-register";
export const CHECK_MOBILE_VERIFICATION = "/api/user/verify-mobile-phone";
export const REGISTER_BUSINESS = "/api/business/registration-details";
export const REGISTER_SITE = "/api/business/confirm-address-details";
export const REGISTER_ADMIN_USER = "/api/user/create-admin-user";
export const ACCOUNT_TYPE = "/api/business/set-account-type";
export const GET_ACTION = "/api/actions/get";
export const ON_SKIP = "/api/actions/skip";
export const ON_BACK = "/api/actions/back";
export const ON_CANCEL = "/api/actions/cancel";
export const REGISTRATION_STATUS = "/api/user/check-user-registration-status";
export const LICENSE_PLAN_INITIAL_SETTINGS = "/api/license/get-initial-settings";
export const LICENSE_PLAN_CALCULATE = "/api/license/calculate";
export const LICENSE_PLAN_CREATE = "/api/license/create";
export const PROCESS_PAYMENT = "/api/payments/process";
export const CHECK_AFFILIATE_REGISTRATION_STATUS = "/api/business/check-affiliate-registration-status";*/

//logout
export const LOGOUT = "/api/logout";

//user
export const GET_USER = "/api/user/get-my-personal-user-details";
export const UPDATE_USER_PROFILE = "/api/user/update-profile-details";
export const REMOVE_USER_AVATAR = "/api/user/delete-profile-image";

//menu
export const GET_MENU = "/api/menu";
export const GET_ADMIN_MENU = "/api/admin/menu";

//company data
export const LOOKUP_ADVANCED_COMPANY_HOUSE = "/api/company-house/advanced-lookup";
export const LOOKUP_COMPANY_HOUSE = "/api/company-house/lookup";
export const GET_COMPANY_TYPES = "/api/business/get-company-types";
export const GET_BUSINESS_SITES = "/api/business/get-my-trading-sites";
export const GET_BUSINESS_DEPARTMENTS = "/api/business/get-my-business-departments";
export const GET_BUSINESS_USERS = "/api/business/get-my-business-users";
export const GET_ADMIN_SUPPORT_USERS = "/api/support/admin-support-agents";

//dashboards
export const GET_BUSINESS_DASHBOARD = "/api/business/dashboard";
export const GET_AFFILIATE_DASHBOARD = "/api/affiliate/dashboard";

//admin
export const GET_CRITICAL_ACTIONS = "/api/actions/get-critical-actions"
//export const GET_SITE_OWNERSHIP_OPTIONS = "/api/business/confirm-address-settings";
export const CHECK_URL_PERMISSIONS = "/api/user/check-url";
export const GET_PAGE_TITLE = "/api/get-page-title";
export const GET_URL_QUICKLINKS = "/api/get-url-quicklinks";
export const GET_BUSINESS_BY_ID = (id: string) => `/api/admin/businesses/get-business/${id}`;
export const GET_BUSINESS_PROCESS_ACTIONS = (id: string | number) => `/api/admin/businesses/${id}/actions`;
export const UPDATE_BUSINESS_AFFILIATE_MANAGER = (id: string | number) => `/api/admin/businesses/${id}/affiliate-manager`;
export const GET_AFFILIATE_MANAGER_OPTIONS = "/api/admin/affiliate-managers";
export const AUTHORIZE_AFFILIATE = "/api/admin/authorize-affiliate";
export const STATUS_UPDATES_GET = "/api/status-updates/get";
export const STATUS_UPDATES_CREATE = "/api/status-updates/create";
export const STATUS_UPDATES_UPDATE = "/api/status-updates/update";
export const STATUS_UPDATES_DELETE = "/api/status-updates/delete";
export const STATUS_UPDATES_GET_ADMIN = "/api/admin/status-updates/get";
export const STATUS_UPDATES_CREATE_ADMIN = "/api/admin/status-updates/create";
export const STATUS_UPDATES_UPDATE_ADMIN = "/api/admin/status-updates/update";
export const STATUS_UPDATES_DELETE_ADMIN = "/api/admin/status-updates/delete";
export const APPROVE_VAT = "/api/admin/approve-vat";
export const UPLOAD_AFFILIATE_AGREEMENT = "/api/affiliate-onboarding/affiliate-agreement";
export const CONFIRM_AFFILIATE_BANK_PAYMENT = "/api/admin/affiliate-onboarding/confirm-bank-payment";
export const CANCEL_AFFILIATE_APPLICATION = "/api/admin/affiliate-onboarding/cancel";

//list
export const GET_LIST = (path: string) => `/api${path}/get-list`;
export const CREATE_OBJECT = (path: string) => `/api${path}/create`;
export const EDIT_OBJECT = (path: string) => `/api${path}/update`;
export const DELETE_OBJECT = (path: string) => `/api${path}/delete`;
export const BULK_DELETE_OBJECTS = (path: string) => `/api${path}/bulk-delete`;
export const IMPORT_VALIDATION = (path: string) => `/api${path}/preview-import`;
export const IMPORT_CSV = (path: string) => `/api${path}/import`;
export const IMPORT_TEMPLATE = (path: string) => `/api${path}/download-import-template`;
export const GET_OPTIONS = (path: string) => `/api${path}`;
export const ADMIN_NOTIFICATIONS_AFFECTED_USERS = "/api/admin/notifications/affected-users";
export const GET_NOTIFICATIONS_COUNT = "/api/notifications/count";

// affiliate API keys
export const AFFILIATE_API_KEYS_CREATE = "/api/affiliates/api-keys/create";
export const AFFILIATE_API_KEY_STATUS = (id: number) => `/api/affiliates/api-keys/${id}/status`;
export const ADMIN_AFFILIATE_API_KEYS_CREATE = "/api/admin/affiliate-api-keys/create";
export const ADMIN_API_KEYS_CREATE = "/api/admin/api-keys/create";
export const ADMIN_API_KEY_STATUS = (id: number) => `/api/admin/api-keys/${id}/status`;
export const ADMIN_AFFILIATE_API_KEY_STATUS = (id: number) => `/api/admin/affiliate-api-keys/${id}/status`;
export const ADMIN_AFFILIATE_SETTINGS = (businessId: number) => `/api/admin/affiliates/${businessId}/settings`;
export const ADMIN_AFFILIATE_USER_SAAS_ROLE = (businessId: number, userId: number) =>
    `/api/admin/affiliates/${businessId}/users/${userId}/saas-role`;

// affiliate invites
export const AFFILIATE_SEND_INVITE_AVAILABLE_VOUCHERS = "/api/affiliates/send-invite/available-vouchers";
export const AFFILIATE_SEND_INVITE_PREVIEW = "/api/affiliates/send-invite/preview";
export const AFFILIATE_SEND_INVITE_SEND = "/api/affiliates/send-invite/send";

export const AFFILIATE_INVITE_OPTIONS = "/api/affiliates/invite-options";
export const EMAIL_INVITE_ADD_MANUAL = "/api/affiliates/invites/manual";
export const EMAIL_INVITE = (id: number | string) => `/api/affiliates/invites/${id}`;
export const EMAIL_INVITE_SET_REGISTERED = (id: number | string) => `/api/affiliates/invites/${id}/set-registered`;
export const EMAIL_INVITE_REJECT = (id: number | string) => `/api/affiliates/invites/${id}/reject`;
export const EMAIL_INVITE_RETRY = (id: number | string) => `/api/affiliates/invites/${id}/retry`;

//data upload centre
export const DATA_UPLOAD_CENTRE_ACTIVE_COUNT = "/api/business/data-upload-centre/active-count";
export const DATA_UPLOAD_CENTRE_PAGE_SUMMARY = "/api/business/data-upload-centre/page-summary";
export const DATA_UPLOAD_CENTRE_GET_LIST = "/api/business/data-upload-centre/get-list";
export const DATA_UPLOAD_CENTRE_ITEMS_GET_LIST = "/api/business/data-upload-centre-items/get-list";
export const DATA_UPLOAD_CENTRE_UPLOAD = "/api/business/data-upload/upload";
export const DATA_UPLOAD_CENTRE_DETECT = "/api/business/data-upload/detect";
export const DATA_UPLOAD_CENTRE_TRIAL_ALLOWANCES = "/api/business/data-upload/trial-allowances";
export const DATA_UPLOAD_CENTRE_CANCEL = (id: number) => `/api/business/data-upload-centre/${id}/cancel`;
export const DATA_UPLOAD_CENTRE_RESTART = (id: number) => `/api/business/data-upload-centre/${id}/restart`;
export const DATA_UPLOAD_CENTRE_ROLLBACK = (id: number) => `/api/business/data-upload-centre/${id}/rollback`;
export const DATA_UPLOAD_CENTRE_ITEM_SKIP = (id: number) => `/api/business/data-upload-centre-items/${id}/skip`;
export const DATA_UPLOAD_CENTRE_ITEM_RETRY_MISSING = (id: number) => `/api/business/data-upload-centre-items/${id}/retry-missing`;
export const DATA_UPLOAD_CENTRE_ITEMS_SKIP = "/api/business/data-upload-centre-items/skip";
export const DATA_UPLOAD_CENTRE_ITEM_EDIT = (id: number) => `/api/business/data-upload-centre-items/${id}/edit`;
export const DATA_UPLOAD_CENTRE_ITEM_FIX = (id: number) => `/business/data-upload-centre-items/${id}/fix`;
export const DATA_AUDIT_ITEMS_BULK_RECHECK = "/api/business/data-audit-items/bulk-recheck";
export const DATA_AUDIT_ITEMS_BULK_SKIP = "/api/business/data-audit-items/bulk-skip";
export const DATA_AUDIT_ITEMS_BULK_UNSKIP = "/api/business/data-audit-items/bulk-unskip";

//data upload centre routes
export const ROUTE_DATA_UPLOAD_CENTRE = "/business/data-upload-centre";
export const ROUTE_DATA_UPLOAD_CENTRE_ITEMS = (id: number) => `/business/data-upload-centre-items/${id}`;
export const ROUTE_IMPORT_DEFINITIONS = "/import-definitions";

//admin government factors
export const ADMIN_GOVERNMENT_FACTORS_UPLOAD = "/api/admin/government-factors/upload";
export const ADMIN_GOVERNMENT_FACTORS_GET_STATUS = "/api/admin/government-factors/get-status";
export const ADMIN_GOVERNMENT_FACTORS_UPLOAD_FACTORS = "/api/admin/government-factors/upload-factors";
export const ADMIN_GOVERNMENT_FACTORS_UPLOAD_FACTORS_STATUS = "/api/admin/government-factors/upload-factors-status";
export const ADMIN_GOVERNMENT_FACTORS_ITEMS_EXCLUDE = "/api/admin/government-factors-items/exclude";
export const ROUTE_ADMIN_GOVERNMENT_FACTORS = "/admin/government-factors";
export const ROUTE_ADMIN_GOVERNMENT_FACTORS_ITEMS = (id: number) => `/admin/government-factors-items/${id}`;

export const MARK_NOTIFICATION_READ = "/api/notifications/read";
export const UPDATE_PROFILE_DETAILS = (path: string) => `/api${path}/update-profile-details`;
export const CLOSE_CHAT = (path: string) => `/api${path}/close`;
export const OPEN_CHAT = (path: string) => `/api${path}/open`;
export const CANCEL_SUPPORT_TICKET = (path: string) => `/api${path}/cancel`

//business
export const UPDATE_BUSINESS = "/api/business/update-business-details";
export const UPDATE_BUSINESS_DEFAULT_SETTINGS = "/api/business/update-business-default-settings";
export const UPDATE_EXTENDED_BUSINESS = "/api/business/update-extended-business-details";
export const UPDATE_BUSINESS_CARBON_COMMITMENT = "/api/business/carbon-commitment/update-commitment";
export const GET_CARBON_REDUCTION_YEARLY_TOTALS = "/api/business/carbon-reduction/yearly-totals";
export const GET_CARBON_REDUCTION_PROJECT_STATUS_SUMMARY = "/api/business/carbon-reduction-projects/status-summary";
export const GET_REPORT_CENTRE_STATS = "/api/report-centre/stats";
export const REFRESH_COMPANY_HOUSE = "/api/business/refresh-company-data";
export const UPDATE_AFFILIATE = "/api/business/update-affiliate-details";

//vehicles
export const VRM_LOOKUP = "/api/business/vehicles/lookup";

//knowledge base
export const GET_KNOWLEDGE_BASE = "/api/knowledge-base/get-by-url";
export const SEARCH_KNOWLEDGE_BASE = "/api/knowledge-base/search";
export const KNOWLEDGE_BASE_BY_CATEGORY = "/api/knowledge-base/by-category";
export const GET_KNOWLEDGE_BASE_POPULAR_CATEGORIES = "/api/knowledge-base/popular-categories";
export const SUPPORT_CLASSIFY = "/api/support/classify";
export const CREATE_SUPPORT_TICKET = "/api/support/create-ticket";

//activities
export const GET_ACTIVITY_TYPES = "/api/activity-type/get";
export const GET_ACTIVITY_SUMMARY = "/api/activity-summary";
export const GET_ACTIVITY_TYPES_WITH_SUB_CATEGORIES = "/api/activity-type/get-with-subcategories";

//actions
export const GET_ACTIONS_COUNT = "/api/actions/count";
export const COMPLETE_ACTION = "/api/actions/complete";
export const ASSIGN_USER_ACTION = "/api/actions/assign-user";

//business setup
export const GET_CURRENT_QUESTION = "/api/questionnaire/current-question";
export const PROCESS_ANSWER = "/api/questionnaire/process-answer";
export const QUESTIONNAIRE_START = "/api/questionnaire/start";
export const QUESTIONNAIRE_RESET = "/api/questionnaire/reset";
export const QUESTIONNAIRE_ASSISTANT_MESSAGE = "/api/questionnaire/assistant-message";

//activities
export const OPTION_LOOKUP = "/api/activities/lookup";
